/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Stain = {
    readonly id?: number;
    name: string;
    category: Stain.category;
    /**
     * abbrevation for the slide to show on the slide thumbnail UI
     */
    abbreviation: string;
    readonly created_at?: string;
    readonly updated_at?: string;
    deliverable?: Stain.deliverable;
    deliverable_document_category?: Stain.deliverable_document_category | null;
}

export namespace Stain {

    export enum category {
        ROUTINE = 'ROUTINE',
        TECH = 'TECH',
        SPEC = 'SPEC',
        IHC = 'IHC',
        CONTROL = 'CONTROL',
        RESCAN = 'RESCAN',
        MOL = 'MOL',
        SO = 'SO',
        ISH = 'ISH',
        FISH = 'FISH',
        IF = 'IF',
        PW_TECH = 'PW-TECH',
        PW_SPEC = 'PW-SPEC',
        PW_IHC = 'PW-IHC',
        PW_SO = 'PW-SO',
        PW_MOL = 'PW-MOL',
        PW_ISH = 'PW-ISH',
        PW_FISH = 'PW-FISH',
        CED_TECH = 'CED-TECH',
        CED_SPEC = 'CED-SPEC',
        CED_IHC = 'CED-IHC',
        CED_MOL = 'CED-MOL',
        CED_ISH = 'CED-ISH',
        CISH = 'CISH',
    }

    export enum deliverable {
        DOCUMENT = 'document',
        SLIDE = 'slide',
        BOTH = 'both',
        OTHER = 'other',
    }

    export enum deliverable_document_category {
        CASE_REPORT = 'Case-Report',
        UNMERGED_CASE_REPORT = 'Unmerged-Case-Report',
        PREVIOUS_PATHOLOGY_REPORT = 'Previous-Pathology-Report',
        PRELIMINARY_REPORT = 'Preliminary-Report',
        UNMERGED_PRELIMINARY_REPORT = 'Unmerged-Preliminary-Report',
        CLINIC_NOTES = 'Clinic-Notes',
        CONSENT_FORM = 'Consent-Form',
        CONSULTATION_REPORT = 'Consultation-Report',
        DOC_CLINICAL = 'Doc-Clinical',
        DOC_INSURANCE = 'Doc-Insurance',
        DIF_REPORT = 'DIF-Report',
        EXTRADEPARTMENTAL_REPORT = 'Extradepartmental-Report',
        FISH_REPORT = 'Fish-Report',
        GROSS_DIAGRAM = 'Gross-Diagram',
        LAB_REPORT = 'Lab-Report',
        LAB_REQUISITION = 'Lab-Requisition',
        SENDOUT_REQUISITION = 'Sendout-Requisition',
        MOLECULAR_REPORT = 'Molecular-Report',
        PATIENT_DEMOGRAPHICS = 'Patient-Demographics',
        REQUISITION_FORM = 'Requisition-Form',
        LOOSE_DOCUMENT = 'Loose-Document',
        MATERIAL_REQUEST = 'Material-Request',
        SELF_PAY_ATTESTATION = 'Self-Pay-Attestation',
        INTERNAL_DOCUMENT = 'Internal-Document',
        INDIGENT_PATIENT_AGREEMENT_NOTICE = 'Indigent-Patient-Agreement-Notice',
        IHC_REPORT = 'IHC-Report',
        CASE_CORRECTION_REQUEST = 'Case-Correction-Request',
        CONSULT_LETTER = 'Consult-Letter',
        TICK_REPORT = 'Tick-Report',
        CASTLE_REPORT = 'Castle-Report',
        ISH_REPORT = 'ISH-Report',
        GROSS_SPECIMEN_PHOTO = 'Gross-Specimen-Photo',
        OTHER = 'Other',
    }


}
